// 海角天崖 · 首页聚合内容（仅用于静态展示，人名为虚构代称，标题均为示意题材）

export interface FeedItem {
  id: number;
  img: string;
  tag: string;
  tagTone: "hot" | "gold" | "ink";
  title: string;
  summary: string;
  reads: string;
  comments: number;
  time: string;
}

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "flat" | "down";
}

export interface BriefItem {
  time: string;
  tag: string;
  text: string;
}

export interface DeepItem {
  img: string;
  kicker: string;
  title: string;
  lead: string;
  body: string;
  series: string;
  reads: string;
}

export interface PersonaItem {
  name: string;
  role: string;
  img: string;
  desc: string;
  heat: string;
}

export const HERO_IMG =
  "https://readdy.ai/api/search-image?query=a%20moody%20editorial%20portrait%20of%20an%20anonymous%20celebrity%20silhouette%20in%20shadow%20with%20dramatic%20red%20rim%20lighting%2C%20wearing%20a%20dark%20long%20coat%20with%20collar%20raised%2C%20face%20partially%20hidden%20for%20anonymity%2C%20dark%20maroon%20background%2C%20cinematic%20paparazzi%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20warm%20amber%20accent%20light%2C%20high%20detail%2C%20editorial%20magazine%20cover%20style&width=860&height=1060&orientation=portrait&seq=hero-portrait-01";

export const HERO_MINI_1 =
  "https://readdy.ai/api/search-image?query=dimly%20lit%20backstage%20corridor%20of%20a%20concert%20venue%20at%20night%2C%20a%20blurred%20figure%20walking%20through%20warm%20amber%20haze%2C%20moving%20lights%20and%20dust%20particles%2C%20moody%20editorial%20reportage%20photography%2C%20red%20and%20gold%20tonal%20palette%2C%20motion%20blur%2C%20cinematic&width=640&height=420&orientation=landscape&seq=hero-mini-1";

export const HERO_MINI_2 =
  "https://readdy.ai/api/search-image?query=close%20up%20of%20an%20empty%20film%20set%20chair%20and%20clapperboard%20under%20a%20single%20warm%20spotlight%2C%20dust%20floating%20in%20the%20light%20beam%2C%20moody%20cinematic%20editorial%20photography%2C%20dark%20maroon%20and%20amber%20palette%2C%20mysterious%20atmosphere%2C%20high%20contrast&width=640&height=420&orientation=landscape&seq=hero-mini-2";

export const FEED_IMGS = [
  "https://readdy.ai/api/search-image?query=anonymous%20celebrity%20with%20baseball%20cap%20and%20mask%20walking%20quickly%20past%20a%20blurred%20night%20city%20background%2C%20paparazzi%20flash%20reflection%2C%20moody%20editorial%20reportage%2C%20warm%20amber%20and%20dark%20tones%2C%20motion%20blur%2C%20cinematic%2C%20high%20detail&width=840&height=560&orientation=landscape&seq=feed-01",
  "https://readdy.ai/api/search-image?query=two%20figures%20talking%20at%20a%20window%20table%20inside%20a%20dim%20private%20lounge%2C%20seen%20from%20outside%20through%20frosted%20glass%2C%20soft%20gold%20lamplight%2C%20mysterious%20whispered%20conversation%2C%20editorial%20reportage%20photography%2C%20dark%20maroon%20tones%2C%20cinematic&width=840&height=560&orientation=landscape&seq=feed-02",
  "https://readdy.ai/api/search-image?query=a%20red%20carpet%20entrance%20at%20night%20with%20velvet%20ropes%20and%20crowds%20blurred%2C%20a%20solitary%20figure%20walking%20away%20from%20camera%2C%20flash%20photography%20glare%2C%20warm%20amber%20and%20crimson%20editorial%20tone%2C%20gossip%20magazine%20reportage%20style%2C%20cinematic&width=840&height=560&orientation=landscape&seq=feed-03",
  "https://readdy.ai/api/search-image?query=stack%20of%20old%20newspapers%20and%20tabloid%20magazines%20on%20a%20wooden%20desk%20under%20a%20desk%20lamp%20at%20night%2C%20reading%20glasses%20and%20coffee%20cup%2C%20warm%20yellow%20lamplight%2C%20investigative%20editorial%20mood%2C%20dark%20background%2C%20high%20detail%2C%20cinematic%20still%20life&width=840&height=560&orientation=landscape&seq=feed-04",
  "https://readdy.ai/api/search-image?query=anonymous%20figure%20holding%20a%20phone%20up%20to%20record%20at%20a%20dark%20crowd%20event%20at%20night%2C%20crowd%20bokeh%20lights%20in%20red%20and%20gold%2C%20sharing%20and%20leaking%20concept%2C%20editorial%20documentary%20photography%2C%20motion%20energy%2C%20cinematic&width=840&height=560&orientation=landscape&seq=feed-05",
  "https://readdy.ai/api/search-image?query=private%20party%20silhouettes%20behind%20a%20sheer%20curtain%20with%20warm%20festival%20lights%2C%20anonymous%20crowd%2C%20mysterious%20gathering%20mood%2C%20muted%20crimson%20and%20amber%20palette%2C%20editorial%20reportage%20photography%2C%20cinematic%20depth&width=840&height=560&orientation=landscape&seq=feed-06",
];

export const DEEP_IMGS = [
  "https://readdy.ai/api/search-image?query=a%20cluttered%20investigator%20desk%20with%20spread%20documents%2C%20timeline%20photos%2C%20magnifying%20glass%20and%20warm%20desk%20lamp%2C%20deep%20dive%20into%20hidden%20connections%20theme%2C%20editorial%20documentary%20style%2C%20warm%20amber%20and%20dark%20tones%2C%20high%20detail%2C%20cinematic%20still&width=900&height=640&orientation=landscape&seq=deep-01",
  "https://readdy.ai/api/search-image?query=a%20long%20empty%20airport%20terminal%20corridor%20at%20night%2C%20a%20single%20far%20figure%20pulling%20a%20suitcase%2C%20speculation%20and%20departure%20mood%2C%20muted%20red%20and%20gold%20lighting%2C%20editorial%20reportage%20photography%2C%20leading%20lines%2C%20cinematic&width=900&height=640&orientation=landscape&seq=deep-02",
];

export const PEOPLE_IMGS = [
  "https://readdy.ai/api/search-image?query=anonymous%20male%20celebrity%20portrait%20in%20shadow%2C%20baseball%20cap%20casting%20face%20in%20darkness%2C%20strong%20red%20backlight%20outline%2C%20dark%20editorial%20portrait%2C%20warm%20tones%2C%20mysterious%20high%20profile%20persona%2C%20high%20detail&width=520&height=520&orientation=squarish&seq=people-01",
  "https://readdy.ai/api/search-image?query=anonymous%20female%20celebrity%20silhouette%20with%20long%20hair%2C%20face%20in%20profile%20half%20shadow%2C%20warm%20amber%20rim%20light%2C%20editorial%20fashion%20portrait%2C%20dark%20moody%20background%2C%20cinematic%2C%20high%20detail&width=520&height=520&orientation=squarish&seq=people-02",
  "https://readdy.ai/api/search-image?query=anonymous%20male%20artist%20portrait%20wearing%20a%20hoodie%20with%20hood%20up%2C%20face%20hidden%20in%20shadow%2C%20single%20dramatic%20crimson%20spotlight%2C%20edgy%20editorial%20portrait%2C%20dark%20warm%20background%2C%20high%20detail%2C%20cinematic&width=520&height=520&orientation=squarish&seq=people-03",
  "https://readdy.ai/api/search-image?query=anonymous%20figure%20in%20large%20sunglasses%20and%20scarf%20hiding%20identity%2C%20low%20key%20lighting%2C%20warm%20gold%20and%20dark%20maroon%20palette%2C%20editorial%20portrait%2C%20gossip%20persona%20vibe%2C%20mysterious%2C%20high%20detail&width=520&height=520&orientation=squarish&seq=people-04",
];

export const HERO_MAIN = {
  kicker: "头条 · 独家深扒",
  tag: "猛料",
  title: "顶流演员被扒出多段旧账：从片酬争议到剧组消失内幕，知情人陆续发声",
  excerpt:
    "多位自称合作过的幕后人员陆续放出聊天截图与时间线，指向一位近年靠大制作翻红的一线演员。本号已按多方信息交叉核验，把目前最能互相印证的几个节点整理成了一条完整的瓜线。",
  meta: ["深扒连载 · 第 12 期", "今日 08:12 更新", "热度 238 万"],
  gallery: [
    { title: "深夜片场离场画面流出", time: "2 小时前", reads: "46.2 万" },
    { title: "剧组内部群聊截图曝光", time: "4 小时前", reads: "31.8 万" },
  ],
};

export const RANK_TOP = [
  { rank: 1, title: "国民小花连夜注销工作室账号，圈内集体噤声", tag: "黑料", heat: "328 万", trend: "up" },
  { rank: 2, title: "选秀冠军被曝长期使用替身录综艺，官方暂未回应", tag: "猛料", heat: "301 万", trend: "up" },
  { rank: 3, title: "某影帝庆功宴后失联三天，经纪人电话拒接", tag: "内幕", heat: "287 万", trend: "flat" },
  { rank: 4, title: "头部经纪公司被曝压榨新人，分成比例再遭扒底", tag: "曝光", heat: "254 万", trend: "up" },
  { rank: 5, title: "古偶新晋男主被挖出早年素人黑历史言论", tag: "黑料", heat: "221 万", trend: "down" },
  { rank: 6, title: "顶流女歌手演唱会后台监控片段疑似外流", tag: "猛料", heat: "198 万", trend: "up" },
  { rank: 7, title: "综艺常驻被曝剧本实锤，多位嘉宾口供对不上", tag: "内幕", heat: "176 万", trend: "flat" },
  { rank: 8, title: "老戏骨被指拖欠群演尾款，讨薪小作文疯传", tag: "曝光", heat: "143 万", trend: "up" },
];

export const SEARCH_TOP = [
  "海角天崖瓜",
  "顶流新瓜",
  "剧组内幕",
  "选秀黑料",
  "影帝塌房",
  "综艺剧本",
  "经纪公司",
  "连夜注销",
];

export const FEEDS: FeedItem[] = [
  {
    id: 1,
    img: FEED_IMGS[0],
    tag: "猛料",
    tagTone: "hot",
    title: "一线小生深夜被拍匆匆离场，同车人身份成谜",
    summary: "狗仔蹲守整夜只拍到背影，车牌与行程已有人扒出，正在逐条对时间线。",
    reads: "128 万",
    comments: 4832,
    time: "18 分钟前",
  },
  {
    id: 2,
    img: FEED_IMGS[1],
    tag: "内幕",
    tagTone: "ink",
    title: "私密会所玻璃前长谈两小时，网友从反射里认出配角",
    summary: "照片放大后有人指认其中一人为某待播剧男二，剧方至今没有回应。",
    reads: "97 万",
    comments: 3104,
    time: "46 分钟前",
  },
  {
    id: 3,
    img: FEED_IMGS[2],
    tag: "黑料",
    tagTone: "gold",
    title: "红毯后台连续三年被爆内定奖杯，这次证据更实",
    summary: "获奖名单流出版与现场核对一致，粉丝已开始大规模刷词条求说法。",
    reads: "211 万",
    comments: 6720,
    time: "1 小时前",
  },
  {
    id: 4,
    img: FEED_IMGS[3],
    tag: "深扒",
    tagTone: "ink",
    title: "陈年旧刊被翻出：顶流五年前采访内容今日成实锤",
    summary: "当年的无心之言被逐字对照，网友直呼「提前写好的剧本」。",
    reads: "86 万",
    comments: 2566,
    time: "2 小时前",
  },
  {
    id: 5,
    img: FEED_IMGS[4],
    tag: "猛料",
    tagTone: "hot",
    title: "现场录制片段疑似流出，指向新片番位之争",
    summary: "声音与口型被多次比对，剪辑痕迹成为争论焦点。",
    reads: "143 万",
    comments: 4401,
    time: "3 小时前",
  },
  {
    id: 6,
    img: FEED_IMGS[5],
    tag: "曝光",
    tagTone: "gold",
    title: "私人聚会隔着纱帘被拍，在场人数成最大谜团",
    summary: "主办方称是普通杀青宴，但订房记录与到访车牌并不支持这个说法。",
    reads: "74 万",
    comments: 1988,
    time: "4 小时前",
  },
];

export const BRIEFS: BriefItem[] = [
  { time: "12:40", tag: "速递", text: "某顶流工作室删除全部新剧宣传博文，评论区已在排队等瓜。" },
  { time: "11:52", tag: "猛料", text: "狗仔预告「内娱顶配」将在今夜放出三段连续视频，暗示是感情向。" },
  { time: "10:36", tag: "内幕", text: "选秀退赛学员直播连线哽咽：有些合同我看完那天就没睡好。" },
  { time: "09:58", tag: "黑料", text: "二线女星被爆早年替身加 AI 换脸出镜，粉丝晒原始物料反证。" },
  { time: "09:12", tag: "曝光", text: "影视城群演爆料：一线剧组盒饭缩水，导演群聊被截出抱怨原话。" },
  { time: "08:47", tag: "速递", text: "头部品牌连夜撤下某代言人海报，官方只回了三个字：在了解。" },
  { time: "08:05", tag: "深扒", text: "网友逐帧比对两场晚会站位，疑似坐实「避嫌」传闻。" },
  { time: "07:36", tag: "猛料", text: "新瓜预告：明早 9 点放「白月光」系男神旧视频，尺度不小。" },
];

export const DEEP: DeepItem[] = [
  {
    img: DEEP_IMGS[0],
    kicker: "专题 · 完整时间线",
    title: "把这两年他能红的每一步都摊开算了一遍",
    lead: "从被平台力捧到资源持续喂到嘴边，我们把他两年内的重要节点做成了一条可核对的时间线。",
    body: "标注了能公开查证的物料，也标出了无法证实的部分，避免只凭一面之词下结论。欢迎当事人或知情人带着证据来对线。",
    series: "第 12 期",
    reads: "238 万",
  },
  {
    img: DEEP_IMGS[1],
    kicker: "特别策划 · 塌房预演",
    title: "「连夜飞走」背后：明星在事情败露前的黄金 72 小时",
    lead: "多次塌房事件里都出现同一个动作——人先走、账后清、声明看情况。这套流程到底是谁定的？",
    body: "我们采访到两位曾参与公关的匿名从业者，把行业内心照不宣的「处理手册」拆给你看。",
    series: "第 9 期",
    reads: "196 万",
  },
];

export const PERSONA: PersonaItem[] = [
  { name: "代号·影帝", role: "疑涉片酬争议", img: PEOPLE_IMGS[0], desc: "靠正剧翻身，近期多笔旧账被翻，经纪公司三连拒评。", heat: "287 万" },
  { name: "代号·小生", role: "连夜被拍主角", img: PEOPLE_IMGS[1], desc: "资源一路攀升，本月热搜出现频率异常走高。", heat: "231 万" },
  { name: "代号·主唱", role: "后台监控外流", img: PEOPLE_IMGS[2], desc: "巡演收官日传出监控片段，主办方称将报警处理。", heat: "198 万" },
  { name: "代号·新星", role: "AI 换脸风波", img: PEOPLE_IMGS[3], desc: "出道三年被扒早期物料，粉丝与黑粉各执一词。", heat: "154 万" },
];

export const FIRE_TAGS = [
  "# 顶流塌房夜",
  "# 连夜注销潮",
  "# 综艺剧本现形记",
  "# 剧组盒饭缩水",
  "# 红毯奖杯疑云",
  "# 白月光旧视频",
];